module.exports = __webpack_public_path__ + "img/header.27d658b0.jpg";